import request from "@/utils/request";
import { generateQry } from "@/utils/helpers";

export function indexSupporters(queryObj) {
  const query = generateQry(queryObj);
  return request({
    url: `api/admin/supporters${query}`,
    method: "get"
  });
}

export function fetchSupporter(slug, locale) {
  return request({
    url: `api/admin/supporters/${slug}`,
    method: "get",
    headers: { "X-locale": locale }
  });
}

export function createSupporter(data) {
  return request({
    url: `api/admin/supporters`,
    method: "post",
    data
  });
}

export function updateSupporter(slug, data) {
  return request({
    url: `api/admin/supporters/${slug}`,
    method: "post",
    data
  });
}

export function deleteSupporter(slug) {
  return request({
    url: `api/admin/supporters/${slug}`,
    method: "delete"
  });
}

export function updateMainImage(id, data) {
  return request({
    url: `api/admin/media/${id}`,
    method: "post",
    data
  });
}
